import { createContext } from "radix-vue";
import { ComputedRef, Ref } from "vue";

export const SEARCH_KEYBOARD_SHORTCUT = "k";

export const [useSearch, provideSearchContext] = createContext<{
  state: ComputedRef<"open" | "closed">;
  open: Ref<boolean>;
  setOpen: (value: boolean) => void;
  toggleSearch: () => void;
}>("Sidebar");
